export function validPhone(str) {
  const reg =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  return reg.test(str);
}

export function validAccountName(str) {
  const reg = /^[a-zA-Z][a-zA-Z\d_]{5,19}$/;
  return reg.test(str);
}

export function validAccountPwd(str) {
  //const reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,20}$/
  const reg = /^(?:(?=.*[0-9].*)(?=.*[a-z].*)(?=.*[A-Z].*))[0-9A-Za-z]{6,20}$/;
  return reg.test(str);
}

export function validZZS(str) {
  const reg = /^[1-9]\d*$/;
  return reg.test(str);
}
